import { FeatureFlagListResponseSchema, type FeatureFlagListResponse } from "@l30/shared";
import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "./client.js";

const FEATURE_FLAGS_KEY = ["feature-flags"] as const;

export function useFeatureFlags() {
  return useQuery({
    queryKey: FEATURE_FLAGS_KEY,
    queryFn: () =>
      apiFetch<FeatureFlagListResponse>("/feature-flags", {}, FeatureFlagListResponseSchema),
    retry: false,
  });
}
